// extracted by mini-css-extract-plugin
export default {"warning":"Footer_warning__ow7wo","info":"Footer_info__AXsHo","arrowIcon":"Footer_arrowIcon__HEFNU"};